import { useEffect } from 'react';
import { useAuthState } from 'shared/auth/AuthState';
import { useCustomerSupport } from 'shared/helpers/CustomerSupport';

export function useOpenSupportFromURL() {
  const { showLauncherMessanger } = useCustomerSupport();
  const state = useAuthState();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const shouldOpenSupport = searchParams.get('open_support') === 'true';

    if (shouldOpenSupport && state === 'authorized') {
      showLauncherMessanger();

      const url = new URL(window.location.href);
      url.searchParams.delete('open_support');
      window.history.replaceState({}, '', url);
    }
  }, [state, showLauncherMessanger]);
}
